export const initialIssuingInvoices = () => ({
    data: [],
    perPage: 10,
    totalRows: 0,
    totalPages: 1,
    currentPage: 1,
    openGenerateDialog: false,
});

export const updateIssuingInvoices = (currentState, action) => {

    return {
        ...currentState,
        issuingInvoices: {
            ...currentState.issuingInvoices,
            ...action.issuingInvoices,
        },
    };
};
